import { Link } from 'gatsby'
import React from 'react'
import parse from 'html-react-parser'
import Image from '../../function/Image'
import replacePath from '../../function/replacePath'
import useGetPost from '../../function/getServicesBySlug'
const IconLink = ({ link, icon }) => {
    return (
        <Link
            to={useGetPost(link?.url) || replacePath(link?.url)}
            className="inline-flex font-[FoundersGrotesk-Bold] font-bold text-[15px] leading-tight items-center gap-x-[10px]"
        >
            <div className="w-[30px]">{icon && <Image {...icon} />}</div>

            {parse(link?.title)}
        </Link>
    )
}

export default IconLink
